import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import { customArray } from 'country-codes-list';
import { px2rem } from '../utils/helpers/style.js';
import { createTheme } from '../utils/theming/create-theme.js';
import { uniqBy } from '../utils/helpers/array.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), true).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var createCountryIdentifier = function createCountryIdentifier(dialingCode, countryCode) {
  return "".concat(dialingCode, "-").concat(countryCode);
};
var destructureCountryIdentifier = function destructureCountryIdentifier(countryIdentifier) {
  var _countryIdentifier$sp = countryIdentifier.split('-'),
    _countryIdentifier$sp2 = _slicedToArray(_countryIdentifier$sp, 2),
    dialingCode = _countryIdentifier$sp2[0],
    countryCode = _countryIdentifier$sp2[1];
  return {
    dialingCode: dialingCode,
    countryCode: countryCode
  };
};

/**
 * height in input field is parsed to rem, because this is how select uses it and we need to keep the same height for both components.
 * See styles of the Select - height in number is read from the theme and then parsed to rem
 */
var propagateTheme = function propagateTheme(phoneInputTheme, defaultTheme) {
  var select = _objectSpread(_objectSpread({}, phoneInputTheme), {}, {
    sizings: {
      s: {
        height: phoneInputTheme.sizings.s.height,
        heading: {
          padding: _objectSpread({}, phoneInputTheme.sizings.s.heading.padding)
        }
      },
      m: {
        height: phoneInputTheme.sizings.m.height,
        heading: {
          padding: _objectSpread({}, phoneInputTheme.sizings.m.heading.padding)
        }
      },
      l: {
        height: phoneInputTheme.sizings.l.height,
        heading: {
          padding: _objectSpread({}, phoneInputTheme.sizings.l.heading.padding)
        }
      }
    }
  });
  var inputField = _objectSpread(_objectSpread({}, phoneInputTheme), {}, {
    sizings: {
      s: {
        height: px2rem(phoneInputTheme.sizings.s.height)
      },
      m: {
        height: px2rem(phoneInputTheme.sizings.m.height)
      },
      l: {
        height: px2rem(phoneInputTheme.sizings.l.height)
      }
    }
  });
  var newTheme = {
    select: {
      web: select
    },
    inputField: {
      web: inputField
    }
  };
  return createTheme(newTheme, defaultTheme);
};
var prepareCountryItems = function prepareCountryItems(itemsProp, mapCountryName, filterItems) {
  /**
   * uniqBy is used to remove duplicates from the list of countries,
   * because there is a known issue with the country-codes-list package where two countries have the same dialing code - 246.
   */
  var items = uniqBy(itemsProp || customArray({
    countryName: '{countryNameEn}',
    countryCode: '{countryCode}',
    dialingCode: '{countryCallingCode}'
  }).map(function (item) {
    return {
      countryName: item.countryName,
      countryCode: item.countryCode,
      dialingCode: item.dialingCode
    };
  }), 'dialingCode');
  var mappedItems = mapCountryName ? items.map(function (item) {
    return _objectSpread(_objectSpread({}, item), {}, {
      countryName: mapCountryName(item)
    });
  }) : items;
  var filteredItems = filterItems ? mappedItems.filter(filterItems) : mappedItems;
  return filteredItems.sort(function (firstCountry, secondCountry) {
    return firstCountry.countryName.localeCompare(secondCountry.countryName);
  });
};
var getSelectedOrDefaultCountry = function getSelectedOrDefaultCountry(countryItems, dialingCode) {
  var selectedItem = countryItems.find(function (item) {
    return item.dialingCode === dialingCode;
  });
  if (!selectedItem && !!dialingCode) {
    console.warn("PhoneInput: No country found for the provided dialing code: ".concat(dialingCode, ". Defaulting to the first country in the list."));
  }
  return {
    dialingCode: (selectedItem === null || selectedItem === undefined ? undefined : selectedItem.dialingCode) || countryItems[0].dialingCode,
    countryCode: (selectedItem === null || selectedItem === undefined ? undefined : selectedItem.countryCode) || countryItems[0].countryCode
  };
};

export { createCountryIdentifier, destructureCountryIdentifier, getSelectedOrDefaultCountry, prepareCountryItems, propagateTheme };
